import React, { Component } from 'react';
import Layout from './Components/Layout';
import axios from 'axios';
import './Dashboard.css';

export class Dashboard extends Component {
    state = {
        stats: {
            rfqsReceived: 12,
            rfqsChange: 15,
            formulasCompleted: 5,
            formulasChange: 8,
            pendingReview: 8,
            pendingChange: -2
        },
        recentActivity: [
            {
                id: 1,
                type: 'rfq',
                title: 'New RFQ submitted',
                description: 'Customer: Acme Supplements',
                time: '2 min ago',
                icon: 'ti-file',
                color: 'blue'
            },
            {
                id: 2,
                type: 'formula',
                title: 'Formula completed',
                description: 'Protein Powder Formula #127',
                time: '15 min ago',
                icon: 'ti-clipboard',
                color: 'purple'
            },
            {
                id: 3,
                type: 'analysis',
                title: 'Costing analysis ready',
                description: 'Multi-Vitamin Complex',
                time: '1 hour ago',
                icon: 'ti-bar-chart',
                color: 'green'
            }
        ],
        quickActions: [
            { id: 1, icon: 'ti-file', title: 'Create New RFQ', link: '/request-quote/new', color: 'blue' },
            { id: 2, icon: 'ti-clipboard', title: 'Add New Formula', link: '/formula/new', color: 'purple' },
            { id: 3, icon: 'ti-bar-chart', title: 'Start Costing Analysis', link: '/draft-estimate/new', color: 'green' }
        ]
    }

    componentDidMount() {
        this.fetchDashboardData();
        this.fetchRecentActivity();
    }

    fetchDashboardData = async () => {
        try {
            const response = await axios.get('/dashboard/stats');
            if (response.data) {
                this.setState({ stats: response.data });
            }
        } catch (error) {
            console.log('Using default stats');
        }
    }

    fetchRecentActivity = async () => {
        try {
            const response = await axios.get('/dashboard/recent-activity');
            if (response.data) {
                this.setState({ recentActivity: response.data });
            }
        } catch (error) {
            this.setState({
                recentActivity: [
                    {
                        id: 1,
                        type: 'rfq',
                        title: 'New RFQ submitted',
                        description: 'Customer: Acme Supplements',
                        time: '2 min ago',
                        icon: 'ti-file',
                        color: 'blue'
                    },
                    {
                        id: 2,
                        type: 'formula',
                        title: 'Formula completed',
                        description: 'Protein Powder Formula #127',
                        time: '15 min ago',
                        icon: 'ti-clipboard',
                        color: 'purple'
                    },
                    {
                        id: 3,
                        type: 'analysis',
                        title: 'Costing analysis ready',
                        description: 'Multi-Vitamin Complex',
                        time: '1 hour ago',
                        icon: 'ti-bar-chart',
                        color: 'green'
                    }
                ]
            });
        }
    }

    getChangeIcon = (change) => {
        if (change > 0) return 'ti-stats-up';
        if (change < 0) return 'ti-stats-down';
        return 'ti-minus';
    }

    getChangeClass = (change) => {
        if (change > 0) return 'positive';
        if (change < 0) return 'negative';
        return 'neutral';
    }

    formatChange = (change) => {
        const sign = change > 0 ? '+' : '';
        return `${sign}${change}% from yesterday`;
    }

    render() {
        const { stats, recentActivity, quickActions } = this.state;

        return (
            <Layout>
                <div className="dashboard">
                    <div className="dashboard-header">
                        <p className="page-subtitle">Welcome to APEX Contract Manufacturing Platform</p>
                    </div>

                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-header">
                                <span className="stat-label">RFQs Received Today</span>
                                <i className="ti-file stat-icon blue"></i>
                            </div>
                            <div className="stat-value">{stats.rfqsReceived}</div>
                            <div className={`stat-change ${this.getChangeClass(stats.rfqsChange)}`}>
                                <i className={this.getChangeIcon(stats.rfqsChange)}></i>
                                {this.formatChange(stats.rfqsChange)}
                            </div>
                        </div>

                        <div className="stat-card">
                            <div className="stat-header">
                                <span className="stat-label">Formulas Completed Today</span>
                                <i className="ti-clipboard stat-icon purple"></i>
                            </div>
                            <div className="stat-value">{stats.formulasCompleted}</div>
                            <div className={`stat-change ${this.getChangeClass(stats.formulasChange)}`}>
                                <i className={this.getChangeIcon(stats.formulasChange)}></i>
                                {this.formatChange(stats.formulasChange)}
                            </div>
                        </div>

                        <div className="stat-card">
                            <div className="stat-header">
                                <span className="stat-label">Pending Review</span>
                                <i className="ti-time stat-icon green"></i>
                            </div>
                            <div className="stat-value">{stats.pendingReview}</div>
                            <div className={`stat-change ${this.getChangeClass(stats.pendingChange)}`}>
                                <i className={this.getChangeIcon(stats.pendingChange)}></i>
                                {this.formatChange(stats.pendingChange)}
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-content">
                        <div className="content-grid">
                            <div className="activity-section">
                                <h2 className="section-title">Recent Activity</h2>
                                <div className="activity-list">
                                    {recentActivity.map(activity => (
                                        <div key={activity.id} className="activity-item">
                                            <div className={`activity-icon ${activity.color}`}>
                                                <i className={activity.icon}></i>
                                            </div>
                                            <div className="activity-content">
                                                <h4 className="activity-title">{activity.title}</h4>
                                                <p className="activity-description">{activity.description}</p>
                                            </div>
                                            <div className="activity-time">
                                                {activity.time}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="actions-section">
                                <h2 className="section-title">Quick Actions</h2>
                                <div className="actions-list">
                                    {quickActions.map(action => (
                                        <a key={action.id} href={action.link} className="action-item">
                                            <div className={`action-icon ${action.color}`}>
                                                <i className={action.icon}></i>
                                            </div>
                                            <span>{action.title}</span>
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default Dashboard;